import CartStore from './cart-store.js?v=20260704-1';
import CartDrawer from './cart-drawer.js?v=20260704-1';
import CartModal from './cart-notification-modal.js?v=20260825-1';

// Helper to determine cart behavior based on screen size
function getCartBehavior() {
  const settings = window.__AGENCY_CART?.settings || {};
  const isMobile = window.innerWidth < 768;
  return isMobile ? settings.cartBehaviorMobile : settings.cartBehaviorDesktop;
}

// Intercept clicks on cart links to open drawer instead
// This runs immediately, before Alpine initializes
function interceptCartLinks() {
  document.addEventListener('click', (event) => {
    if (getCartBehavior() === 'kaching_cart') return;

    const link = event.target.closest('a[href*="/cart"]');
    if (link && link.href) {
      try {
        const url = new URL(link.href);
        // Only intercept if it's going to /cart (not /cart/add or other cart routes)
        if (url.pathname === '/cart' || url.pathname.endsWith('/cart')) {
          event.preventDefault();
          event.stopPropagation();
          // Open the drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          return false;
        }
      } catch (e) {
        // If URL parsing fails, check if href contains /cart
        if (link.href.includes('/cart') && !link.href.includes('/cart/add')) {
          event.preventDefault();
          event.stopPropagation();
          document.dispatchEvent(new CustomEvent('cart:open'));
          return false;
        }
      }
    }
  }, true); // Use capture phase to catch early
}

// Initialize cart link interception immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', interceptCartLinks);
} else {
  interceptCartLinks();
}

function registerCartModule() {
  // Register Global Store
  Alpine.store('cart', CartStore);

  // Register Component Logic
  Alpine.data('cartDrawer', CartDrawer);
  Alpine.data('cartModal', CartModal);

  async function syncCartAndOpen(event, openBehavior) {
    const store = Alpine.store('cart');
    if (!store) return;

    const behavior = openBehavior ?? getCartBehavior();

    // Start linked products refresh immediately — runs in parallel, never blocks UI
    store.refreshLinkedProducts({ fast: true });

    // Show modal instantly with the added item — sync cart totals in background
    if (behavior === 'modal') {
      document.dispatchEvent(new CustomEvent('cart:modal:open', {
        detail: event?.detail
      }));
      store.refreshCart({ skipLinkedProducts: true });
      return;
    }

    if (!event?.detail?.cartSynced) {
      await store.refreshCart({ skipLinkedProducts: true });
    }

    switch (behavior) {
      case 'alert':
        alert('Item added to cart!');
        break;
      case 'redirect':
        window.location.href = '/cart';
        break;
      case 'kaching_cart':
        break;
      case 'drawer':
      default:
        document.dispatchEvent(new CustomEvent('cart:open'));
        break;
    }
  }

  // Listen for cart:item:added (ajax forms, product cards, cart-store)
  document.addEventListener('cart:item:added', (event) => {
    syncCartAndOpen(event);
  });

  // Product cards also dispatch cart:update
  document.addEventListener('cart:update', () => {
    syncCartAndOpen(null, getCartBehavior());
  });
}

// Register on alpine:init event (fires when Alpine initializes)
document.addEventListener('alpine:init', registerCartModule);

// Fallback: If Alpine is already available, register immediately
if (window.Alpine) {
  registerCartModule();
}

